import axios from 'axios';
import { convertQuestionsToArray } from '../../../../components/CASAForm/Utilities';
import { submissionBegin, submissionSuccess, submissionFailure } from '../GenericFormServiceActions/SubmissionAction';
import { addFormSubmissionFailed } from '../../FormPropertyAction/FormPropertyAction';

export const industryAssistSubmission = (webappurlForms, accessToken, formProperties, formData) => {
    return dispatch => {
        const data = {
            "rootFormCode": formProperties.rootFormCode,
            "formCode": formProperties.formCode,
            "formData": {"steps": convertQuestionsToArray(formData.steps)},
            "name": formProperties.name,
            "version": formProperties.version,
            "orgid": formProperties.orgid,
            "organisationArn": formProperties.organisationArn
        }

        const options = {
            headers: {
                'Authorization': "Bearer " + accessToken,
                'Accept': 'application/json',
                'Content-Type': 'multipart/form-data'
            }
        };

        const uploadFileQuestion = formData.steps[0].questions.uploadDocuments;
        const formDataObject = new FormData();
        
        formDataObject.append("request", btoa(JSON.stringify(data)));
        
        uploadFileQuestion.answer.fileDetails.map(file => {
            formDataObject.append("files", file.file)
        });
        
        dispatch(submissionBegin());
        return axios.post(webappurlForms + "/api/myCASA/Forms/SubmitIndustryAssist/v1", formDataObject, options)
            .then(response => {
                if (response.data.wasSuccessful) {
                    return dispatch(submissionSuccess());
                }
                else {
                    dispatch(addFormSubmissionFailed())
                    return dispatch(submissionFailure("System error FSU.1a: " + response.message));
                }
            })
            .catch(error => {
                dispatch(addFormSubmissionFailed())
                return dispatch(submissionFailure(error.response ? error.response.data.errors : error));
            });
    };
}
